































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_newInvoiceData_newInvoice, GQL_newInvoiceData_newInvoice_orders_customerParty } from '../../../../queries/__generated__/newInvoiceData';
import { isEqual, assign } from 'lodash';

@Component
export default class InvoiceCustomerPartyPicker extends Vue {
  public assign = assign;

  @Prop(Object) public invoice!: GQL_newInvoiceData_newInvoice;

  private get uniqueCustomerParties(): GQL_newInvoiceData_newInvoice_orders_customerParty[] {
    const arr: GQL_newInvoiceData_newInvoice_orders_customerParty[] = [];

    this.invoice.orders.forEach(order => {
      if (
        !arr.some(unique => isEqual(
          { ...order.customerParty, id: null },
          { ...unique, id: null },
        ))
      ) {
        arr.push(order.customerParty);
      }
    });

    return arr;
  }
}
